export const emailTextContent = {
  btnText: "sales@gammastack.com",
  email: "mailto:sales@gammastack.com"
};
